import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Execution, SubTool } from '../models';

@Injectable({providedIn: 'root'})
export class ExecutionService {

  constructor(
    private http: HttpClient,
  ) { }

    getToolInfo(idExecution: string, can_public_access_this?: boolean): Promise<Execution> {
        let cpat = can_public_access_this? true: false;
        let  _params: HttpParams = new HttpParams().set('id-execution', idExecution)
        if (cpat) _params = _params.set('can_public_access_this', cpat.toString())

      return this.http.get<Execution>(`${environment.apiUrl}/GetExecutionInfo`,
      {
          params: _params
      }
    ).toPromise();
  }

  getAvailableSubTool(idExecution: string): Promise<{ section_list: SubTool[] }> {
    return this.http.get<{ section_list: SubTool[] }>(`${environment.apiUrl}/GetAvailableSubtool`,
      {
        params: new HttpParams().set('id-execution', idExecution)
      }
    ).toPromise();
  }
}
